import React from 'react';
import './product-marque.scss';
const ProductMarque = () => {
  return (
    <div className="product-marque">
      <div className="sliding-background">
        <img src="https://ik.imagekit.io/iwcam3r8ka/custom-tiles/202103/f2497f5a-c119-4185-baa9-c3e116c0ef10.png" />
        <img src="https://ik.imagekit.io/iwcam3r8ka/custom-tiles/202103/f2497f5a-c119-4185-baa9-c3e116c0ef10.png" />
        <img src="https://ik.imagekit.io/iwcam3r8ka/custom-tiles/202103/f2497f5a-c119-4185-baa9-c3e116c0ef10.png" />
      </div>
    </div>
  );
};

export default ProductMarque;
